import {roles} from '@eitje/bridge'
import {BaseLayout} from './layout'
import {useGetLayoutClickHandler} from './use_get_layout_click_handler'

export const Layout = ({externalLink, modalLink, to, onClick, enableRole, navigateOptions = {}, analytics, ...rest}) => {
	const handleClick = useGetLayoutClickHandler({onClick, to, modalLink, externalLink, navigateOptions, analytics})

	if (enableRole) return <RoleLayout onClick={handleClick} enableRole={enableRole} {...rest} />

	return <BaseLayout onClick={handleClick} {...rest} />
}

const RoleLayout = ({enableRole, roleEnv, disabled, ...rest}) => {
	// If no roleEnv prop is passed, simply 'any' env is used.
	const notPermitted = roles.useRoleMessage({roles: enableRole, env: roleEnv})

	// always prefer role message above custom, content-related message, as to be utmost clear
	// e.g. if something is disabled because there is no contract, adding a contract wouldn't suffice since the user doesn't have a contract role
	disabled = notPermitted || disabled

	return <BaseLayout disabled={disabled} {...rest} />
}
